<!--
@Author: DKing
@Desc: 产品服务-慧用工h5+
@Date: 2021-04-22
-->
<template>
  <div>
    <div class="banner-box">
      <div class="min-width-pc">
        <p class="title">免费高效<br>解决企业用工荒难题</p>
        <p class="text">慧用工，免费高效解决企业用工荒难题，帮助个人多渠道就业</p>
        <span class="btnFullColor" @click="jumpPage">立即咨询</span>
      </div>
    </div>

    <div class="min-width-pc">
      <div class="title-txt">解决问题，从场景开始</div>
      <div class="tab-box">
        <div class="tabs">
          <span class="tab" :class="activeType == 'one' && 'active'" @click="clickTab('one')">企业</span>
          <span class="tab" :class="activeType == 'two' && 'active'" @click="clickTab('two')">新个体</span>
          <p class="slider"></p>

          <div class="tab-content">
            <div class="item" v-for="(item, index) in productList" :key="index">
              <img :src="item.imgUrl" alt="">
              <span class="title">{{item.title}}</span>
              <span>{{item.text}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="title-txt">我们能为你做什么</div>
      <div class="setion2-box">
        <!-- <img src="./../../../static/pc/产品服务/img_product_phone@2x.png" alt="" v-if="getAddress == 'hyhyg'"> -->
        <img src="./../../../static/pc/产品服务/img_product_phonehy.png" alt="">

        <span>
          灵工助手是基于慧用工场景化灵活用工服务平台，通过大数据分析，智能匹配个人与岗位的需求，为求职者提供更优质、更真实的工作岗位，让招工企业省时省心。
        </span>
      </div>
    </div>

    <!-- 弹窗form -->
    <pc-form-dialog :source='source'><span class="pc-form-text">慧用工｜致力于助力每一个优秀的公司</span></pc-form-dialog>
    <!-- 底部悬浮框 -->
    <pc-suspension-dialog :source="sourceF"></pc-suspension-dialog>

  </div>
</template>

<script type="text/javascript">
import pcFormDialog from '../../components/pcFormDialog.vue'
import pcSuspensionDialog from "../../components/pcSuspensionDialog";

export default {
  name: "prodServ-h5",
  data() {
    return {
      productList:[
        {imgUrl:'./../../../static/pc/产品服务/product_icon_zhaorennan@2x.png', title:'招人难', text:'就业人员不稳定，合适的人员难找'},
        {imgUrl:'./../../../static/pc/产品服务/product_icon_guanliluan@2x.png', title:'管理乱', text:'招工渠道过多，无法统一管理'},
        {imgUrl:'./../../../static/pc/产品服务/product_icon_xiaolvdi@2x.png', title:'效率低', text:'招工时效、质量、服务跟不上'}
      ],
      activeType: 'one',
      source: '',
      sourceF: '',
      // getAddress: ''
      
    }
  },

  components: {
    "pc-form-dialog": pcFormDialog,
    "pc-suspension-dialog": pcSuspensionDialog
  },
  
  created() {
    // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=cpfw_hyg' : '&pageFrom=cpfw_hyg';
    this.sourceF = this.source + "_f";
    // 获取展示logo的标记
    // this.getAddress = this.getSiteAddress().whichHui;   
  },

  methods: {
    clickTab(type){
      this.activeType = type;
      if(type == 'one'){
        this.productList = [
          {imgUrl:'./../../../static/pc/产品服务/product_icon_zhaorennan@2x.png', title:'招人难', text:'就业人员不稳定，合适的人员难找'},
          {imgUrl:'./../../../static/pc/产品服务/product_icon_guanliluan@2x.png', title:'管理乱', text:'招工渠道过多，无法统一管理'},
          {imgUrl:'./../../../static/pc/产品服务/product_icon_xiaolvdi@2x.png', title:'效率低', text:'招工时效、质量、服务跟不上'}
        ]

      } else if(type == 'two'){
        this.productList = [
          {imgUrl:'./../../../static/pc/产品服务/product_icon_zhongzuonanzhao@2x.png', title:'工作难找', text:'适合自己的岗位难找'},
          {imgUrl:'./../../../static/pc/产品服务/product_icon_zhognjieguoduo@2x.png', title:'中介过多', text:'中介层层转介绍，过程复杂'},
          {imgUrl:'./../../../static/pc/产品服务/product_icon_butouming@2x.png', title:'不透明', text:'招工信息不透明，费用不透明'}
        ]
      }
    },

    jumpPage(){
      eventBus.$emit("pcOperaDiaLog", true);
    },
  }
}
</script>

<style lang="scss" scoped>
.banner-box{
  background:url('./../../../static/pc/产品服务/banner_product_2.png') no-repeat;
  background-size: cover;
  background-color: #111010;
  .text{
    font-size: 14px;
    color: #FFFFFF;
    margin-bottom: 54px;
    text-align: left;
  }
  
}
.title-txt{
  margin-top:88px;
}
.min-width-pc{
  padding-bottom:30px;
  .tab-box{
    margin-top: 80px;
    .tabs{
      color: rgba(23, 30, 46, 100);
      font-size: 24px;
      text-align: center;
      // font-family: AlibabaPuHuiTi-Medium;
      position: relative;
      top:2px;
      .tab{
        display: inline-block;
        width: 180px;
        height: 44px;
        border-bottom: 4px solid rgba(25, 133, 255,0);
        font-weight: bold;
        cursor: pointer;
      }

      .active{
        color:rgb(25, 133, 255);
        border-bottom: 4px solid rgba(25, 133, 255,1);
        -webkit-transition: all 0.8s;
        -moz-transition: all 0.8s;
        -ms-transition: all 0.8s;
        -o-transition: all 0.8s;
        transition: all 0.8s;
      }

      .tab-content{
        margin-top:57px;
        display: flex;
        justify-content: space-around;
        .item{
          width:386px;
          height: 348px;
          text-align: center;
          background-color: rgba(255, 255, 255, 1);
          box-shadow: 0px 20px 60px -20px rgba(0, 0, 0, 0.1);
          color: #403F3F;
          font-size: 16px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          padding:0 53px;
          img{
            width:138px;
            margin-bottom:41px;
          }
          .title{
            color: rgba(64, 63, 63, 100);
            font-size: 18px;
            // font-family: AlibabaPuHuiTi-Medium;
            margin-bottom:16px;
            font-weight: bold;
          }
          &:hover{
            background-color: rgba(255, 255, 255, 1);
            box-shadow: 0px 20px 20px 0px rgba(16, 15, 15, 0.09);
            position: relative;
            top:-5px;
          }
        }
      }

      // .item:hover{
      //   color:rgb(25, 133, 255);
      //   border-bottom: 4px solid rgba(25, 133, 255,1);
      //   -webkit-transition: all 0.8s;
      //   -moz-transition: all 0.8s;
      //   -ms-transition: all 0.8s;
      //   -o-transition: all 0.8s;
      //   transition: all 0.8s;
      // }

      // .item{
      //   display: inline-block;
      //   width: 180px;
      //   height: 44px;
      //   position: relative;
      //   &::after{
      //     content: '';
      //     display: block;
      //     width: 100%;
      //     height: 4px;
      //     position: absolute;
      //     bottom: -2px;
      //     left:0;
      //     background-color: rgb(25, 133, 255);
      //     margin-top:6px;
      //     display: none;
      //   }
      // }

      // .item:hover{
      //   color:rgb(25, 133, 255);
      //   &::after{
          // -webkit-transition: all 0.8s;
          // -moz-transition: all 0.8s;
          // -ms-transition: all 0.8s;
          // -o-transition: all 0.8s;
          // transition: all 0.8s;
      //     // opacity: 1;
      //     display: block;
      //   }

      //   // 渐现
      //   // transition: .3s ease-in-out;

      //   // 放大
      //   // transform: scale(2);
      //   // transition: all 1s linear; 
      // }
    }
    
    .slider{
      width: 100%;
      height: 1px;
      border-radius: 24px;
      background-color: rgba(207, 207, 207, 1);
      box-shadow: 0px 20px 60px 0px rgba(0, 0, 0, 0.1);
      margin-bottom:57px;
    }
  }
  .setion2-box{
    margin-top:77px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img{
      width:502px;
      height: 672px;
      margin-right:103px;
    }
    span{
      display: inline-block;
      width: 595px;
      line-height: 56px;
      color: rgba(64, 63, 63, 100);
      font-size: 24px;
    }
  }
}


</style>


// WEBPACK FOOTER //
// src/views/pc/prodServ_h5.vue